"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAnalysisMessage = exports.whyScoreLabel = exports.impactLabel = exports.conflictsHeading = exports.keyPointsHeading = exports.ANALYSIS_COPY = void 0;
/**
 * Every fixed string the analysis surfaces render, in one place so copy review
 * (including the locked rules: no "Dubious", no verification framing) happens
 * against a single module. Screen-reader labels count as visible copy.
 */
exports.ANALYSIS_COPY = {
    metrics: {
        credibility: 'Confidence',
        bias: 'Bias',
        originality: 'Originality',
        depth: 'Depth',
    },
    sections: {
        keyPoints: 'Key Points',
        conflicts: 'Conflicts of Interest',
        keySources: 'Key Sources',
        keyTakeaways: 'Key Takeaways',
    },
    list: {
        expandAll: 'Expand all details',
        collapseAll: 'Collapse all details',
        showAll: 'Show all key points',
        showFewer: 'Show fewer key points',
        alwaysShowAll: 'Always show all',
        expandAllReasons: 'Expand all reasons',
        collapseAllReasons: 'Collapse all reasons',
    },
    skim: {
        title: 'SKIM',
        playAll: 'Play all key segments',
        watch: 'watch',
        save: 'Save',
    },
    tiers: {
        short: 'Short',
        medium: 'Medium',
        relaxed: 'Relaxed',
    },
    keyPoint: {
        forAndAgainst: 'For and Against',
        forAndAgainstHint: 'Sources that agree, disagree, or are neutral',
        reason: 'Reason',
    },
    conflict: {
        significance: 'Significance',
    },
    claimTabs: {
        facts: 'Claimed Facts',
        opinions: 'Opinions',
        claims: 'Claims',
    },
    claimChart: {
        facts: 'Facts',
        opinions: 'Opinions',
        claims: 'Claims',
    },
    article: {
        goToArticle: 'Go to this article',
        noSnippets: 'No snippets found',
        noKeySources: 'No key sources available',
    },
    empty: {
        noKeySources: 'No key sources found',
    },
    deleteAnalysis: {
        action: 'Delete analysis',
        title: 'Delete YouTube analysis?',
        description: 'You are about to permanently delete this YouTube analysis',
        irreversible: 'This action cannot be undone!',
        cancel: 'Cancel',
        confirm: 'Delete',
        pending: 'Deleting...',
        deleted: 'YouTube analysis deleted',
        failed: 'Failed to delete analysis',
    },
};
const keyPointsHeading = (count) => `${exports.ANALYSIS_COPY.sections.keyPoints} (${count})`;
exports.keyPointsHeading = keyPointsHeading;
const conflictsHeading = (count) => `${exports.ANALYSIS_COPY.sections.conflicts} (${count})`;
exports.conflictsHeading = conflictsHeading;
const impactLabel = (level) => `Impact: ${level}`;
exports.impactLabel = impactLabel;
const whyScoreLabel = (score) => `Why ${score}%?`;
exports.whyScoreLabel = whyScoreLabel;
/** The delete confirmation as one plain-text body, for native alerts. */
const deleteAnalysisMessage = (videoTitle) => {
    const { description, irreversible } = exports.ANALYSIS_COPY.deleteAnalysis;
    const title = videoTitle?.trim();
    return `${description}${title ? ` “${title}”` : ''}.\n\n${irreversible}`;
};
exports.deleteAnalysisMessage = deleteAnalysisMessage;
